import { getDeltas, isBasePeriod } from '../../../utils/dataUtils';
export const getChartDataFromDaysAgedResponse = (data, colors) => {
    const { daysAged = [] } = (data || {});
    // Base categories to process
    const baseCategories = ['0-30', '31-45', '46-90', '91-120', '120+'];
    // Check if Unknown category exists and if other categories have data
    const unknownCategory = daysAged.find(({ daysAtDealer }) => daysAtDealer === 'Unknown');
    const hasOtherCategoriesWithData = baseCategories.some((category) => {
        const categoryData = daysAged.find(({ daysAtDealer }) => daysAtDealer === `${category} days`);
        const { cpoCount = 0, newCount = 0, usedCount = 0 } = categoryData || {};
        return cpoCount > 0 || newCount > 0 || usedCount > 0;
    });
    // Determine final categories to include
    const categoriesToProcess = [...baseCategories];
    if (unknownCategory && hasOtherCategoriesWithData) {
        categoriesToProcess.push('Unknown');
    }
    return categoriesToProcess.map((category) => {
        const categoryValues = daysAged.find(({ daysAtDealer }) => (daysAtDealer === 'Unknown'
            ? category === 'Unknown'
            : daysAtDealer === `${category} days`));
        const { cpoCount = 0, newCount = 0, usedCount = 0, } = categoryValues || {};
        return [
            {
                category,
                color: colors.NEW || '',
                subcategory: 'New',
                value: newCount,
            },
            {
                category,
                color: colors.USED || '',
                subcategory: 'Used',
                value: usedCount,
            },
            {
                category,
                color: colors.CPO || '',
                subcategory: 'CPO',
                value: cpoCount,
            },
        ];
    }).flat();
};
export const getFormattedUnitsSoldData = (res) => {
    const lastUpdatedUTC = res?.lastUpdatedUTC || '';
    const unitsSoldArray = res?.unitsSold || [];
    const baseUnitsSold = unitsSoldArray.find(({ comparisonPeriod }) => isBasePeriod(comparisonPeriod));
    const { cpoCount = 0, newCount = 0, totalCount = 0, usedCount = 0, } = (baseUnitsSold || {}).unitsSold || {};
    const deltas = getDeltas(unitsSoldArray);
    return {
        deltas,
        lastUpdatedUTC,
        totals: {
            cpoCount,
            newCount,
            totalCount,
            usedCount,
        },
    };
};
// Whether to show "no data" on top of the bar chart only
// This happens when there is data in totals, but all chart values are zero
export const showNoDataChartMask = (chartData, totals) => ((chartData || []).length > 0
    && (chartData || []).every(({ value }) => value === 0)
    && ((totals || {}).totalCount || 0) !== 0);
